var UitkBadgeSizes = {
    SMALL: 'small',
    LARGE: 'large'
};
var UitkBadgeStandardThemes = {
    STANDARD: 'standard',
    EMPHASIS: 'emphasis',
    INFO: 'info',
    FEATURED: 'featured',
    BRAND: 'brand',
    WARNING: 'warning',
    POSITIVE: 'positive'
};
var UitkBadgeLoyaltyThemes = {
    LOW: 'lowtier',
    MID: 'midtier',
    HIGH: 'hightier',
    VIP: 'vip'
};
var UitkBadgeProgramThemes = {
    DEAL: 'deal',
    MEMBER: 'member',
    TRIP_SAVINGS: 'trip',
    SUPPLIER_PROMO: 'supplierpromo',
    VIRTUAL_MARKET_COACH: 'vmc'
};
var UitkBadgeNotificationThemes = {
    UNREAD: 'unread',
    ACTIVITY: 'activity',
    ACTION: 'action',
    DEFAULT: 'default',
    INVERSE: 'inverse'
};

export { UitkBadgeLoyaltyThemes, UitkBadgeNotificationThemes, UitkBadgeProgramThemes, UitkBadgeSizes, UitkBadgeStandardThemes };
